import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    async unpublish(event) {
        event.preventDefault()
        
        let confirmed = confirm("Are you sure you want to unpublish your fund?\n\nYou can republish by revisiting the fund.")

        if (!confirmed) {
            return
        }

        const response = await fetch( this.element.href, {
            method: "POST",
            headers: {
                "Accept": "text/html",
                "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
            },
            credentials: "same-origin"
        })

        if (response.ok) {
            window.location.href = this.element.dataset.fundUrl
        }
    }
} 